function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import cn from 'classnames';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import anim from '../../fade-in-out.scss';
import Footer from '../footer';
import { CardItem } from './components/card-item';
import css from './content.scss';
const Content = ({
  isAddonFlow,
  cardItems,
  onSelectionClick,
  selectedProductsAmount,
  onChangeHowManyInEachBox,
  onQuantityPerSizeChange,
  onChangeHowManyAddonInEachBox,
  onQuantityInCart
}) => {
  return /*#__PURE__*/React.createElement("section", {
    className: css.contentWrapper
  }, /*#__PURE__*/React.createElement("header", {
    className: css.infoHeader
  }, /*#__PURE__*/React.createElement("span", {
    className: css.headingText
  }, "Select the products and quantities per box!"), /*#__PURE__*/React.createElement("span", {
    className: css.greyedHeadingText
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: anim,
    key: selectedProductsAmount || 0,
    timeout: 250
  }, /*#__PURE__*/React.createElement("span", {
    "data-text": "SelectedAmount"
  }, "(", selectedProductsAmount || 0, " selected)"))), ' ')), /*#__PURE__*/React.createElement("main", {
    className: cn(css.cardListWrapper, {
      [css.addonCardListWrapper]: isAddonFlow
    })
  }, /*#__PURE__*/React.createElement("ul", {
    className: cn(css.cardList, {
      [css.addonCardList]: isAddonFlow
    })
  }, cardItems.map((data, index) => {
    return /*#__PURE__*/React.createElement(CardItem, _extends({
      onQuantityInCart: () =>
      // @todo. auto generated. fix this error
      // @ts-ignore
      onQuantityInCart(data.itemId, data.variant.variantIndex),
      key: index,
      isAddonFlow: isAddonFlow
    }, data, {
      onSelectionClick: onSelectionClick
      // @todo. auto generated. fix this error
      // @ts-ignore
      ,
      onChangeHowManyInEachBox: onChangeHowManyInEachBox
      // @todo. auto generated. fix this error
      // @ts-ignore
      ,
      onChangeHowManyAddonInEachBox: onChangeHowManyAddonInEachBox
      // @todo. auto generated. fix this error
      // @ts-ignore
      ,
      onQuantityPerSizeChange: onQuantityPerSizeChange
    }));
  }))), /*#__PURE__*/React.createElement(Footer, {
    isAddonFlow: isAddonFlow,
    selectedAddonsAmount: selectedProductsAmount
  }));
};
export default Content;